module.exports = __webpack_public_path__ + "img/home-all-3.bbd748cd.png";